import { render, staticRenderFns } from "./OtherSkilss.vue?vue&type=template&id=0b080104&scoped=true&"
import script from "./OtherSkilss.vue?vue&type=script&lang=js&"
export * from "./OtherSkilss.vue?vue&type=script&lang=js&"
import style0 from "./OtherSkilss.vue?vue&type=style&index=0&id=0b080104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b080104",
  null
  
)

export default component.exports